(() => {
const FAMILIES = ["Citrus","Floral","Woody","Spicy","Gourmand","Green","Resinous","Musky"];

const T1 = [
  {note:"Bergamot", ans:"Citrus", teach:"Green, bitter citrus from Calabria. It opens more perfumes than any other single material because it lifts what sits behind it without adding sweetness."},
  {note:"Vetiver", ans:"Woody", teach:"A grass, botanically. The roots smell of dry earth and smoke, so perfumery files it with the woods. One of the few materials that reads clean and dirty at once."},
  {note:"Tonka Bean", ans:"Gourmand", teach:"Almond, hay and warm tobacco. Its coumarin is why so many fragrances carry a soft powdery sweetness underneath, including ones that never smell edible."},
  {note:"Oakmoss", ans:"Green", teach:"A lichen, not a moss. Inky and forest-floor damp, and the backbone of the chypre family. IFRA limits mean modern versions are far quieter than vintage ones."},
  {note:"Labdanum", ans:"Resinous", teach:"A sticky resin from rockrose. Leathery, honeyed, faintly animal. Most of what people call amber is labdanum married to vanilla."},
  {note:"Iris", ans:"Floral", teach:"Made from the rhizome after years of drying, never the flower. Cool, powdery, faintly carrot-like, and among the costliest materials in use."},
  {note:"Cardamom", ans:"Spicy", teach:"Green and camphorous rather than hot. It bridges a citrus opening into a woody heart, which is why it turns up in so much oud."},
  {note:"Ambroxan", ans:"Musky", teach:"A synthetic drawn from ambergris chemistry. Faintly salty, skin-close, enormously diffusive. It does the heavy lifting in most modern blue fragrances."}
];

const T2 = [
  {order:["Lemon","Rose","Sandalwood"], teach:"Volatility tracks molecular weight almost exactly. Citrus molecules are small and light, so they leave first. Woods are heavy and slow, which is why they are still there at hour eight."},
  {order:["Mint","Jasmine","Patchouli"], teach:"Mint is gone in minutes. Jasmine holds the middle for hours. Patchouli is famously tenacious and can survive on fabric for days."},
  {order:["Grapefruit","Lavender","Vanilla"], teach:"Lavender is the odd one. It sits between top and heart, and perfumers treat it as either depending on the dose."},
  {order:["Pink Pepper","Iris","Oud"], teach:"Pink pepper is a top-note sparkle. Iris blooms slowly through the heart. Oud is among the heaviest materials in use, and often the last thing left."},
  {order:["Bergamot","Geranium","Tonka Bean"], teach:"A textbook spine. Citrus over rosy geranium over coumarin is the outline of the entire fougère family."},
  {order:["Orange Blossom","Cinnamon","Musk"], teach:"Cinnamon lingers longer than most people expect. Musks are built to outlast everything, and they are what carries the dry-down."}
];

const T3 = [
  {desc:"Damp forest floor after rain. Inky, bitter, faintly mushroom-like.", ans:"Oakmoss", wrong:["Vetiver","Cypress","Fern"],
   teach:"The word people reach for is mossy. The giveaway is the inky bitterness, closer to wet bark than to anything green and growing."},
  {desc:"Cool, dry, powdery. Somewhere between violet, raw carrot and old face powder.", ans:"Iris", wrong:["Heliotrope","Mimosa","Violet"],
   teach:"Almost nobody names it first time, because it does not smell like a flower at all. The carrot note is the tell."},
  {desc:"Sweet smoke and dried fruit. Pipe shop rather than ashtray.", ans:"Tobacco", wrong:["Leather","Incense","Birch Tar"],
   teach:"Leather is drier and more animal. Incense is colder and more resinous. That dried-fruit sweetness is what marks tobacco out."},
  {desc:"Clean, warm, slightly salty. Smells less like a thing than like skin.", ans:"Ambroxan", wrong:["White Musk","Ambergris","Cotton"],
   teach:"Ambergris is close, but rarer and more marine. When a fragrance smells like a better version of your own skin, this is usually why."},
  {desc:"Medicinal and barnyard at first, then sweet, resinous and dark.", ans:"Oud", wrong:["Leather","Castoreum","Myrrh"],
   teach:"That opening is real agarwood, and it is why first-timers recoil. Synthetic oud accords skip the barnyard and go straight to the sweet resin."},
  {desc:"Bitter green stem, camphor, and a cool shadow underneath.", ans:"Galbanum", wrong:["Basil","Violet Leaf","Petitgrain"],
   teach:"A resin so aggressively green it can read as almost petrol-like. It is what gives the classic green florals their edge."},
  {desc:"Hay, almond, tobacco leaf, and a soft powdery sweetness.", ans:"Tonka Bean", wrong:["Vanilla","Benzoin","Praline"],
   teach:"Vanilla is rounder and more single-minded. Tonka carries hay and almond, and the hay is the reliable clue."},
  {desc:"Dry, dusty, church-cold. Smoke with no sweetness in it.", ans:"Frankincense", wrong:["Myrrh","Cade","Vetiver"],
   teach:"Myrrh is warmer and more bitter-medicinal. Frankincense is the cold, dusty, high-ceilinged one."}
];

const TRIALS = [
  {key:'sits',  name:"Where It Sits",   blurb:"Place a raw material in the family it belongs to.", data:T1},
  {key:'first', name:"What Goes First", blurb:"Set three notes in the order they leave the skin.", data:T2},
  {key:'what',  name:"What Is It",      blurb:"Read a description and name the material.",         data:T3}
];

const $ = id => document.getElementById(id);
const shuffle = a => a.map(v => [Math.random(), v]).sort((x, y) => x[0] - y[0]).map(p => p[1]);
const best = {
  get(k){ try { return JSON.parse(localStorage.getItem('neve.nose.' + k)) } catch(e){ return null } },
  set(k, v){ try { localStorage.setItem('neve.nose.' + k, JSON.stringify(v)) } catch(e){} }
};
const show = id => ['nvHome','nvPlay','nvResult'].forEach(s => $(s).classList.toggle('hide', s !== id));

function home(){
  show('nvHome');
  $('nvTrials').innerHTML = '';
  TRIALS.forEach((t, i) => {
    const b = best.get(t.key);
    const el = document.createElement('button');
    el.className = 'trial';
    el.innerHTML = `<span class="n">0${i + 1}</span>
      <span class="t"><strong>${t.name}</strong><span>${t.blurb}</span></span>
      <span class="b">${b != null ? `Best ${b} / ${t.data.length}` : `${t.data.length} questions`}</span>`;
    el.onclick = () => start(i);
    $('nvTrials').appendChild(el);
  });
}

let S = null;
function start(i){
  S = {i, trial:TRIALS[i], pool:shuffle(TRIALS[i].data), q:0, score:0, log:[]};
  $('nvName').textContent = TRIALS[i].name;
  show('nvPlay');
  ask();
}

const SKIP = `<div class="skip"><button class="link quiet" id="nvSkip">No idea, show me</button></div>`;

function ask(){
  const {trial, pool, q} = S;
  $('nvProg').textContent = `${q + 1} / ${pool.length}`;
  $('nvFill').style.width = (q / pool.length * 100) + '%';
  $('nvAfter').innerHTML = '';
  hideJump();
  const item = pool[q];
  const box = $('nvAsk');
  box.innerHTML = '';
  box.classList.remove('ask');
  void box.offsetWidth;
  box.classList.add('ask');

  if (trial.key === 'sits'){
    const opts = shuffle([item.ans, ...shuffle(FAMILIES.filter(f => f !== item.ans)).slice(0, 3)]);
    box.innerHTML = `<p class="q">Which family?</p><h2 class="subject">${item.note}</h2>
      <div class="opts">${opts.map(o => `<button class="opt" data-v="${o}">${o}</button>`).join('')}</div>${SKIP}`;
    box.querySelectorAll('.opt').forEach(b => b.onclick = () => gradePick(b.dataset.v, item));
    $('nvSkip').onclick = () => gradePick(null, item);
  }

  else if (trial.key === 'first'){
    box.innerHTML = `<p class="q">Set them in order.</p><h2 class="subject">Three notes</h2>
      <div class="fade">
        <div class="ends"><span>First to fade</span><span>Last to leave</span></div>
        <div class="grad"></div>
        <div class="slots">
          ${['Top','Heart','Base'].map((t, k) => `<button class="slot" data-k="${k}"><span class="tier">${t}</span><span class="val"></span></button>`).join('')}
        </div>
        <div class="chips">${shuffle(item.order).map(n => `<button class="chip" data-v="${n}">${n}</button>`).join('')}</div>
      </div>${SKIP}`;
    wireFade(item);
  }

  else {
    const opts = shuffle([item.ans, ...item.wrong]);
    box.innerHTML = `<p class="q">Which material?</p><h2 class="subject quote">“${item.desc}”</h2>
      <div class="opts">${opts.map(o => `<button class="opt" data-v="${o}">${o}</button>`).join('')}</div>${SKIP}`;
    box.querySelectorAll('.opt').forEach(b => b.onclick = () => gradePick(b.dataset.v, item));
    $('nvSkip').onclick = () => gradePick(null, item);
  }
}

function gradePick(pick, item){
  const ans = item.ans;
  [...$('nvAsk').querySelectorAll('.opt')].forEach(b => {
    b.disabled = true;
    if (b.dataset.v === ans) b.classList.add('hit');
    else if (pick && b.dataset.v === pick) b.classList.add('miss');
  });
  close(pick === null ? 'skip' : pick === ans, item.teach.replace(ans, `<b>${ans}</b>`), pick === null ? ans : null,
        {label:item.note || ans, tag:item.note ? ans : '', teach:item.teach});
}

function wireFade(item){
  const slots = [...$('nvAsk').querySelectorAll('.slot')];
  const chips = [...$('nvAsk').querySelectorAll('.chip')];
  const placed = [null, null, null];
  const arm = () => {
    const next = placed.indexOf(null);
    slots.forEach((s, k) => s.classList.toggle('armed', k === next));
  };
  const lock = () => {
    slots.forEach(s => { s.disabled = true; s.classList.remove('armed'); });
    chips.forEach(c => c.disabled = true);
  };
  const paint = () => {
    slots.forEach((s, k) => s.querySelector('.val').textContent = placed[k] || '');
    chips.forEach(c => c.classList.toggle('used', placed.includes(c.dataset.v)));
    arm();
    if (placed.includes(null)) return;
    lock();
    slots.forEach((s, k) => s.classList.add(placed[k] === item.order[k] ? 'hit' : 'miss'));
    const ok = placed.every((n, k) => n === item.order[k]);
    close(ok, item.teach, ok ? null : item.order.join(' · '),
          {label:item.order.join(' · '), tag:'In order', teach:item.teach});
  };
  chips.forEach(c => c.onclick = () => {
    if (placed.includes(c.dataset.v)) return;
    const next = placed.indexOf(null);
    if (next < 0) return;
    placed[next] = c.dataset.v;
    paint();
  });
  slots.forEach((s, k) => s.onclick = () => {
    if (!placed[k]) return;
    placed[k] = null;
    for (let j = k; j < 2; j++){ placed[j] = placed[j + 1]; placed[j + 1] = null; }
    paint();
  });
  $('nvSkip').onclick = () => {
    lock();
    slots.forEach((s, k) => { s.classList.add('hit'); s.querySelector('.val').textContent = item.order[k]; });
    close('skip', item.teach, item.order.join(', '),
          {label:item.order.join(' · '), tag:'In order', teach:item.teach});
  };
  arm();
}

function close(state, teach, reveal, entry){
  if (state === true) S.score++;
  if (entry && state !== true) S.log.push(entry);
  const last = S.q === S.pool.length - 1;
  const label = state === 'skip' ? ['skipped','The answer'] : state ? ['ok','Right'] : ['no','Missed it'];
  $('nvAfter').innerHTML = `<div class="after">
      <p class="verdict ${label[0]}">${label[1]}${reveal ? ' · ' + reveal : ''}</p>
      <p class="teach">${teach}</p>
      <button class="pill" id="nvGo">${last ? 'Result' : 'Next'}</button>
    </div>`;
  $('nvFill').style.width = ((S.q + 1) / S.pool.length * 100) + '%';
  const skip = $('nvAsk').querySelector('.skip');
  if (skip) skip.remove();
  $('nvGo').onclick = () => { if (last) result(); else { S.q++; ask(); } };
  $('nvGo').focus({preventScroll:true});
  watchGo();
}

let io = null;
function watchGo(){
  const go = $('nvGo'), jump = $('nvJump');
  if (!go || !jump) return;
  jump.onclick = () => go.click();
  if (io) io.disconnect();
  if (!('IntersectionObserver' in window)) return;
  io = new IntersectionObserver(
    ([e]) => jump.classList.toggle('on', !e.isIntersecting),
    {threshold:1}
  );
  io.observe(go);
}
function hideJump(){
  if (io) io.disconnect();
  const jump = $('nvJump');
  if (jump) jump.classList.remove('on');
}

const CATALOG = '/collections/all-fragrances';

// Builds the container if the section markup predates it, so JS and Liquid
// can never fall out of step.
function slot(id){
  let el = $(id);
  if (!el){
    const res = $('nvResult');
    el = document.createElement('div');
    el.id = id;
    res.insertBefore(el, res.querySelector('.actions'));
  }
  return el;
}

function result(){
  const n = S.pool.length, pct = S.score / n;
  const prev = best.get(S.trial.key);
  const isBest = prev == null || S.score > prev;
  if (isBest) best.set(S.trial.key, S.score);

  $('nvResName').textContent = S.trial.name + ' · ' +
    (isBest ? (prev == null ? 'First run' : 'New best') : `Best ${prev} / ${n}`);
  $('nvScore').innerHTML = `${S.score}<span> / ${n}</span>`;
  $('nvRank').textContent =
    pct === 1 ? "Nothing left to teach you here." :
    pct >= .8  ? "A trained nose." :
    pct >= .6  ? "Close, and getting closer." :
    pct >= .35 ? "You know more than you think." :
                 "Everyone starts here.";

  slot('nvRecap').innerHTML = S.log.length
    ? `<p class="recap-head">Worth another look</p>
       <ul class="recap">${S.log.map(e => `
         <li><p class="rlab">${e.label}${e.tag ? `<i>${e.tag}</i>` : ''}</p>
             <p class="rteach">${e.teach}</p></li>`).join('')}</ul>`
    : `<p class="clean">You missed nothing. The order changes on every run, so it is worth one more.</p>`;

  const lastTrial = S.i === TRIALS.length - 1;
  const next = TRIALS[(S.i + 1) % TRIALS.length];
  slot('nvNextUp').innerHTML = lastTrial ? '' :
    `<a class="nextup" href="#" id="nvNextGo">
       <span class="n">0${S.i + 2}</span>
       <span class="t"><strong>${next.name}</strong><span>${next.blurb}</span></span>
       <span class="k">Next trial</span>
     </a>`;
  const go = $('nvNextGo');
  if (go) go.onclick = e => { e.preventDefault(); start(S.i + 1); };

  let cat = $('nvCat');
  if (!cat){
    cat = document.createElement('a');
    cat.id = 'nvCat';
    cat.className = 'pill ghost';
    cat.href = CATALOG;
    cat.textContent = 'THE CATALOGUE';
    $('nvResult').querySelector('.actions').appendChild(cat);
  }
  cat.classList.toggle('hide', !lastTrial);

  hideJump();
  show('nvResult');
  window.scrollTo({top:0, behavior:'auto'});
}

const begin = $('nvBegin');
if (begin) begin.onclick = () => start(0);
$('nvAgain').onclick = () => start(S.i);
$('nvBack').onclick = home;
home();
})();